/**
 * LOCKED LITERAL — the dark aubergine open-task banner. In round 1 all three
 * challenger directions independently turned this white; the colour contract
 * (aubergine = decided/dark furniture) is mandatory fix #1 and this component
 * is the enforcement. Serif title per the verdant register.
 * Do not restyle, lighten, or re-author per surface.
 */
export function OpenTaskBanner({
  eyebrow,
  title,
  meta,
  children,
}: {
  eyebrow: string
  title: string
  meta: string
  children?: React.ReactNode
}) {
  return (
    <div className="rounded-lg bg-primary px-5 py-4 text-primary-foreground">
      <div className="text-[0.6875rem] font-semibold uppercase tracking-[0.1em] text-white/70">
        {eyebrow}
      </div>
      <div className="mt-1 font-serif text-xl font-semibold">{title}</div>
      <div className="mt-1 text-sm text-white/80">{meta}</div>
      {children}
    </div>
  )
}
